module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tray full-list",
    class: [{
      active: _vm.isActive
    }, _vm.options.color],
    attrs: {
      "id": "fulllist"
    }
  }, [_c('h1', {
    staticClass: "full-list-title"
  }, [_vm._v(_vm._s(_vm.options.pageTitle))]), _vm._v(" "), _c('i', {
    staticClass: "material-icons tray-icon-close full-list-icon-close",
    on: {
      "click": _vm.closeList
    }
  }, [_vm._v("close")]), _vm._v(" "), _c('div', {
    staticClass: "card",
    class: _vm.options.color
  }, [_c('h2', {
    staticClass: "card-h2",
    class: [{
      's-icon': _vm.options.titleIcon
    }]
  }, [_c('span', [(_vm.options.titleIcon) ? _c('i', {
    staticClass: "material-icons card-icon"
  }, [_vm._v(_vm._s(_vm.options.titleIcon))]) : _vm._e(), _vm._v(" \n        " + _vm._s(_vm.options.title) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('BarChart', {
    attrs: {
      "chart-type": 'bar',
      "chart-data": _vm.fullList,
      "chart-height": 75,
      "bar-color": _vm.options.barColors,
      "show-legend": false,
      "label-prefix": _vm.options.prefix
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "card",
    class: _vm.options.color
  }, [_c('h2', {
    staticClass: "card-h2",
    class: [{
      's-icon': _vm.options.titleIcon
    }]
  }, [_c('span', [(_vm.options.titleIcon) ? _c('i', {
    staticClass: "material-icons card-icon"
  }, [_vm._v(_vm._s(_vm.options.titleIcon))]) : _vm._e(), _vm._v("\n        " + _vm._s(_vm.options.title) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('table', {
    staticClass: "fetch navigation-board",
    class: [{
      'is-loading': _vm.isLoading
    }, _vm.options.color]
  }, [(_vm.options.ths) ? _c('thead', [_c('tr', _vm._l((_vm.options.ths), function(heading) {
    return _c('th', [_vm._v(_vm._s(heading))])
  }))]) : _vm._e(), _vm._v(" "), _c('tbody', _vm._l((_vm.fullList), function(rankItem, index) {
    return _c('tr', {
      staticClass: "full-list-row"
    }, [_c('td', [_c('router-link', {
      attrs: {
        "to": {
          name: _vm.options.link,
          params: {
            id: rankItem.id
          }
        }
      }
    }, [_vm._v(_vm._s(index + 1))])], 1), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": {
          name: _vm.options.link,
          params: {
            id: rankItem.id
          }
        }
      }
    }, [_vm._v(_vm._s(rankItem.title))])], 1), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": {
          name: _vm.options.link,
          params: {
            id: rankItem.id
          }
        }
      }
    }, [_vm._v(_vm._s(_vm.options.prefix) + _vm._s(Number(rankItem.amount).toLocaleString('en-US')))])], 1)])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "loader-dots-wrap center",
    class: [{
      'is-loading': _vm.isLoading
    }]
  }, [_c('LoaderDots')], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-430860ee"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/trays/FullList.vue
// module id = 463
// module chunks = 1